export default {
  en: {
    titleLineOne: 'One of our team',
    titleLineTwo: 'will be in touch',
    subtitle: 'As we don\'t yet fully support your region. Some services may be impaired,\n' +
      'someone from the ClassForKids Team will contact you.',
    button: 'Find Out More',
  },
};
